export default __webpack_public_path__ + "assets/af498b.svg";